import request from "@/api/request";

export default {
    getList: async data => request({url: '/console/download.Report/getList', data}),
    delReport: async data => request({url: '/console/download.Report/delReport', data}),
    download: async data => request({url: '/console/download.Report/download', data}),
}
